import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IClinicalNote } from '../ClinicalNote';

export interface AcknowledgeCounsellingNoteInput {
    noteId: string;
    notes: string | null;
}

export function useAcknowledgeCounsellingNote() {
    const queryClient = useQueryClient();

    return useMutation<IClinicalNote, AppMedError, AcknowledgeCounsellingNoteInput>({
        mutationKey: [QueryKeys.clinicalNotes, 'patientAcknowledge'],
        mutationFn: async ({ noteId, notes }) => {
            return await ClinicalNoteApi.acknowledgeCounsellingNote(noteId, notes);
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes, 'patientView', variables.noteId] });
        },
    });
}
